import { configureStore, createReducer } from '@reduxjs/toolkit'
import type {
  LacedAvailableCurrencies,
  LacedAvailableLocales,
  Location
} from 'types/localisation'

interface translationProps {
  availableLocales: string[]
  availableCurrencies: string[]
  locale: LacedAvailableLocales
  currency: LacedAvailableCurrencies
  location: Location
  translations: {
    [key: string]: {
      [key: string]: string
    }
  }
}

const translationReducer = (props: translationProps) =>
  createReducer(props, (builder) => {
    builder.addDefaultCase((state) => state)
  })

const translationStore = (props: translationProps) =>
  configureStore({
    reducer: translationReducer(props)
  })

export default translationStore
